import { ExtensionIdentifier } from 'monaco-editor/esm/vs/platform/extensions/common/extensions.js';
import { URI } from 'monaco-editor/esm/vs/base/common/uri.js';
let DEFAULT_EXTENSION = {
    identifier: new ExtensionIdentifier('monaco'),
    isBuiltin: true,
    isUserBuiltin: true,
    isUnderDevelopment: false,
    extensionLocation: ( URI.from({ scheme: 'extension', path: '/' })),
    name: 'monaco',
    publisher: 'microsoft',
    version: '1.0.0',
    engines: {
        vscode: "1.79.0"
    },
    targetPlatform: "web"
};
function setDefaultExtension(extension) {
    DEFAULT_EXTENSION = extension;
}
function getDefaultExtension() {
    return DEFAULT_EXTENSION;
}
export { getDefaultExtension, setDefaultExtension };
